import { useEffect, useMemo, useState } from 'react';

export const useForm = ( initialForm = {}) => {
    const [ formState, setFormState ] = useState( initialForm );
    const [elementResetFlag, setElementResetFlag] = useState(false); //para select-lists mediante su `key`


    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onInputChangeForNumber = ({ target }) => {

        const { name, value } = target;

        // Limpiar el valor eliminando comas 
        const cleanValue = value.replace(/,/g, '');

        // Verificar si el valor es un número válido (permitir números decimales)
        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);

        // Si el valor no es un número válido, no actualizamos el estado
        if (!validNumber) {
            return;
        }
        // Si el valor está vacío o es solo un punto, lo dejamos como está
        if (cleanValue === '' || cleanValue === '.') {
            setFormState({
                ...formState,
                [name]: value,
                [`clean_${name}`]: parseFloat(cleanValue) // Guardar el valor limpio
            });
            return;
        }

        // Separar la parte entera de la parte decimal
        let [integerPart, decimalPart] = cleanValue.split('.');

        // Limitar la parte decimal a 2 dígitos
        if (decimalPart !== undefined) {
            decimalPart = decimalPart.slice(0, 2);  // Mantener solo los primeros 2 decimales
        }

        // Formatear solo la parte entera
        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));

        // Si hay una parte decimal, la mantenemos sin formatear y truncada a 2 dígitos
        const formattedValue = decimalPart !== undefined
            ? `${formattedInteger}.${decimalPart}` // Mantener la parte decimal truncada
            : formattedInteger; // Solo la parte entera formateada

        setFormState({
            ...formState,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue) // Guardar el valor limpio
        });

    }

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState({
            ...formState,
            acceptedFiles: arrayAccepted
        });
    }

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState({
            ...formState,
            fileRejections: arrayRejections
        });
    }

    const onResetForm = () => {
        setFormState( initialForm );
        setElementResetFlag(prevFlag => !prevFlag); //para select-lists mediante su `key
    }

    return {
        ...formState,
        formState,
        elementResetFlag,
        setFormState,
        onInputChange,
        onSelectSearchChange,
        onResetForm,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange,
        onInputChangeForNumber
    }

}